<highcharts-chart
    class="vc-stacked-bar-chart no-title"
    [style.height]="height"
    [options]="options"
    (chartInstance)="onChartInstance($event)">
</highcharts-chart>
